import React, { useReducer, useEffect, createContext, useContext, useState } from 'react'
import { pageReducer, getSlideRecords, deleteSlide, getSlideToken, save_updateTags, getSearchList, updateSlidename, myGroups, shareSlidetoGroup } from "../Service";
import { AgGridReact } from 'ag-grid-react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { AddUploadSlide } from "../AddUpload/AddUploadSlide";
import { Form, Modal, Button, ListGroup } from 'react-bootstrap'
import { FaPlusCircle, FaSearch } from "react-icons/fa"

export const Slides = () => {

    const initialState = {
        allowPaging: true,
        number_of_items: 10,
        index: 0,
        totalRecords: 0,
        slide_name: '',
        hideDeletedSlideStatus: true,
        slideList: [],
        // taglist: [],
        modalVisible: false,
        SlidenameTitle: '',
        searchList: {
            slidenamelist: [],
            taglist: []
        },
        myJoinedGroups: [],
        user_id: ''
    }

    const pageDispatcher = {
        setSlideRecords: (data) => dispatch({ type: 'set_slideRecords', payload: data }),
        setTagList: (data) => dispatch({ type: 'set_taglist', payload: data }),
        setTagObj: (data) => dispatch({ type: 'set_tagObj', payload: data }),
        updateIndex: (updatedIndex) => dispatch({ type: 'set_updateIndex', payload: updatedIndex }),
        set_modalVisible: (value) => dispatch({ type: 'set_modalVisible', payload: value }),
        set_slideNameTitle: (title) => dispatch({ type: 'set_slidenameTitle', payload: title }),
        setSearchList: (data) => dispatch({ type: 'set_searchList', payload: data }),
        setMyJoinedGroups: (data) => dispatch({ type: 'set_setMyJoinedGroups', payload: data }),
    }

    const [pageState, dispatch] = useReducer(pageReducer, initialState);


    useEffect(() => {
        pageDispatcher.updateIndex(0);
        myGroups(pageDispatcher)
        getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '')
        getSearchList(pageDispatcher)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div className="sl-page">
            <PageContext.Provider value={{ pageState, pageDispatcher }}>
                <NotificationContainer />
                <SlideListComponent />
            </PageContext.Provider>
        </div>
    )
}

const SlideListComponent = () => {
    const { pageState, pageDispatcher } = useContext(PageContext);
    const [showUploadComponent, setShowUploadComponent] = useState(false);

    const [selectedRowRecord, setSelectedRowRecord] = useState('')

    const [searchParams, setSearchParams] = useState({
        searchparams: {
            slide_name: '',
            tags: []
        }
    });
    const [disableBtn, setDisableBtn] = useState(true)
    let arr = [];

    const [isSlideNameEditable, setIsSlideNameEditable] = useState(false);

    const initialState = {
        modalVisible: false,
        selectedSlideID: ''
    }

    const [manageSlideState, setManageSlideState] = useState(initialState)

    function getTagsOptions() {
        pageState.searchList.taglist.map(el => {
            if (el.tagsarr !== null) {
                arr.push(el.tagsarr)
            }
            return 0
        })
        arr = arr.flat();
        let uniqueChars = [...new Set(arr)];
        // console.log("uniqueChars", uniqueChars)
        return uniqueChars
    }

    const deletebyslideId = (slide_id) => {
        if (window.confirm('Sure want to delete?')) {
            getSlideToken(slide_id).then(res => {
                if (res && res.data && res.data.slide_token) {
                    let obj = {
                        slide_id: slide_id
                    }
                    let slide_accessToken = res.data.slide_token;
                    deleteSlide(obj, slide_accessToken)
                        .then(res => {
                            if (res && res.data.Message) {
                                getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '')
                                NotificationManager.success(res.data.Message, '', 2000)
                            }
                        }).catch(e => {
                            console.log(e)
                        })

                }
            })
        }
    }

    const StatusIcon = (params) => {
        switch (params.colDef.headerName) {
            case "Status": {
                const s = params.data.status;
                let label, modifier;
                if (s === 0)       { label = 'Initialized'; modifier = 'initialized'; }
                else if (s === 1)  { label = 'Uploaded';     modifier = 'uploaded'; }
                else if (s === 2)  { label = 'Processing';   modifier = 'processing'; }
                else if (s === 3)  { label = 'Done';         modifier = 'done'; }
                else if (s === 4)  { label = 'Processing';   modifier = 'processing'; }
                else if (s === 5)  { label = 'Done';         modifier = 'done'; }
                else if (s === 7)  { label = 'Flagged Delete'; modifier = 'deleted'; }
                else if (s === 8)  { label = 'Deleting';     modifier = 'deleted'; }
                else if (s === 9)  { label = 'Deleted';      modifier = 'deleted'; }
                else if (s === -1) { label = 'Error';        modifier = 'error'; }
                else               { return <span>{s}</span>; }

                return (
                    <span className={`sl-status-badge sl-status-badge--${modifier}`}>
                        {label}
                    </span>
                );
            }
            default:
                return null;
        }
    }

    const onCellValueChanged = (event) => {
        let obj = {
            slide_id: event.data.slide_id,
            slide_name: event.data.slide_name
        }
        updateSlidename(obj).then(res => {
            if (res && res.data.Message) {
                getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '')
                getSearchList(pageDispatcher);
                NotificationManager.success(res.data.Message, '', 2000)
            }
        })
    }

    const checkStatusForSlideView = (params) => {
        if (params.data.status === 0) {
            setShowUploadComponent(true)
            setSelectedRowRecord(params.data);
            // pageDispatcher.set_slideNameTitle(params.data.slide_name)
            pageDispatcher.set_modalVisible(true);
        }
        if (params.data.status === 3 || params.data.status === 5) {
            const win = window.open('/slideView/' + params.data.slide_id, "_blank");
            win.focus();
        }
    }

    const convertToDateFormat = (timeData) => {
        if (timeData) {
            let date_val = new Date(timeData * 1000);
            let humanDateFormat = date_val.toLocaleString("en-AU", { timeZone: 'Asia/Kolkata' });
            return humanDateFormat;
        }
        else return ""
    }

    const LinkButton = (props) => {
        return (
            <>
                <a href="#!" style={{ color: "black" }} >
                    <i className="fa fa-ellipsis-v fa-lg" aria-hidden="true" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                    <div className="dropdown-menu" id="selectedElement" style={{ lineHeight: '15px', fontSize: '13px',marginLeft:'-45%' }}>
                        <a className="dropdown-item" href="#!" id="sharetogroup" onClick={() => setManageSlideState({ ...manageSlideState, modalVisible: true, selectedSlideID: props.slide_id })}><i class="fa fa-users" aria-hidden="true"></i> Share to a group</a>
                        <a className="dropdown-item" href="#!" id="remove" onClick={() => alert("Testing")}><i class="fa fa-cog" aria-hidden="true"></i> Other settings</a>
                    </div>
                </a>
            </>
        )
    }
    const columnDefs = [
        {
            headerName: "Slides",
            field: "slide_name",
            sortable: true,
            width: 300,
            editable: isSlideNameEditable,
            suppressMovable: true,
            cellRendererFramework: (params) => {
                return <div>

                    {params.data.status === 5 && <i className="fa fa-star" style={{ color: 'gold' }} aria-hidden="true"></i>}
                    <button onClick={() => {
                        checkStatusForSlideView(params)
                    }} style={{ color: "#6347D3", border: "none", backgroundColor: 'transparent', cursor: 'pointer' }}>{params.data.slide_name}
                    </button>

                    <i className="fa fa-pencil-square-o fa-lg" aria-hidden="true" style={{ top: '16px', position: 'absolute', 'right': '0px', cursor: 'pointer' }} onClick={() => setIsSlideNameEditable(!isSlideNameEditable)}></i>

                </div>


            }
        },
        {
            headerName: 'Image',
            field: 'wsImage' || '',
            width: 350,
            wrapText: true,
            height: 250,
            cellRendererFramework: (params) => {
                if (params.data.wsImage && (params.data.status === 3 || params.data.status === 5)) {
                    return (
                        <button style={{ color: "#6347D3", border: "none", backgroundColor: 'transparent', cursor: 'pointer' }} onClick={() => checkStatusForSlideView(params)}>
                            <img
                                // src={`data:image/jpg;base64,${params.data.wsImage}`}
                                src={`${params.data.wsImage}`}
                                alt="ResponsiveImage"
                                className="img-fluid" />
                        </button>
                    )
                }
                else {
                    return (
                        <p>No img</p>
                        //     <div className="spinner-border text-info" role="status">
                        //     <span className="sr-only">Loading...</span>
                        //   </div>
                    )
                }
            }
        },
        {
            headerName: "Created Date",
            field: "unixtime",
            width: 120,
            wrapText: true,
            suppressMovable: true,
            cellRendererFramework: (params) =>
                convertToDateFormat(params.data.unixtime || '')

        },
        {
            headerName: "Expiry Date",
            field: "expiry_date",
            width: 120,
            wrapText: true,
            suppressMovable: true,
            cellRendererFramework: (params) =>
                convertToDateFormat(params.data.expiry_date || '')
        },
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            width: 170,
            suppressMovable: true,
            cellRendererFramework: (params) => StatusIcon(params)

        },
        {
            headerName: "Tags",
            field: 'tagsarr',
            width: 270,
            sortable: true,
            suppressMovable: true,
            cellRendererFramework: (params) => {
                return (
                    <TagsInput
                        taglistdata={params.data.tagsarr}
                        slide_id={params.data.slide_id} />
                )
            }
        },
        {
            headerName: "Delete",
            field: "status",
            sortable: true,
            width: 150,
            suppressMovable: true,
            cellRendererFramework: (params) => {
                return <a href="#!" style={{ color: '#DC2626', fontSize: '12px', textDecoration: 'none' }}
                    onClick={() => deletebyslideId(params.data.slide_id)}>Delete</a>
            }
        },
        {
            headerName: "Manage",
            field: "manage  ",
            sortable: true,
            width: 295,
            cellRendererFramework: (params) => <LinkButton slide_id={params.data.slide_id} />
        }
    ]

    const onGridReady = params => {
        params.api.resetRowHeights();
    }

    const totalPages = Math.ceil(pageState.totalRecords / pageState.number_of_items) || 1;
    const currentPage = pageState.index + 1;

    return (
        <div>
            {pageState.slideList && (
                <>
                    {/* Control Bar */}
                    <div className="sl-control-bar">
                        <div className="sl-control-row">
                            {/* Add Slide Button */}
                            <button type="button" className="sl-btn-add" onClick={() => {
                                setShowUploadComponent(false)
                                pageDispatcher.set_modalVisible(true)
                            }}>
                                <FaPlusCircle />
                                Add Slide
                            </button>

                            {/* Search Bar */}
                            <div className="sl-search-bar">
                                <FaSearch className="search-icon" />
                                <input type="search" id="slidenamelist"
                                    placeholder="Search slides by name..."
                                    onChange={(event) => {
                                        if (event.target.value) {
                                            setDisableBtn(false)
                                        }
                                        else {
                                            setDisableBtn(true);
                                            getSlideRecords(0, pageState.number_of_items, pageDispatcher, '')
                                        }
                                        setSearchParams({ ...searchParams, searchparams: { ...searchParams.searchparams, slide_name: event.target.value } })
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !disableBtn) {
                                            e.preventDefault();
                                            getSlideRecords(0, pageState.number_of_items, pageDispatcher, searchParams)
                                        }
                                    }}
                                />
                            </div>

                            {/* Pagination */}
                            <div className="sl-pagination">
                                <span className="page-label">Page</span>
                                <span className="page-badge page-badge--purple">{currentPage}</span>
                                <span className="page-of">of</span>
                                <span className="page-badge page-badge--gray">{totalPages}</span>
                                <div className="divider"></div>
                                <span className="page-label">Total slides</span>
                                <span className="page-badge page-badge--teal">{pageState.totalRecords}</span>
                                <div className="divider"></div>
                                {/* First */}
                                <button className="nav-btn" title="First Page" disabled={pageState.index === 0} onClick={() => {
                                    pageDispatcher.updateIndex(0);
                                    getSlideRecords(0, pageState.number_of_items, pageDispatcher, '')
                                }}>
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" /></svg>
                                </button>
                                {/* Prev */}
                                <button className="nav-btn" title="Previous Page" disabled={pageState.index === 0} onClick={() => {
                                    const idx = pageState.index - 1;
                                    pageDispatcher.updateIndex(idx);
                                    getSlideRecords(idx, pageState.number_of_items, pageDispatcher, '')
                                }}>
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                                </button>
                                {/* Next */}
                                <button className="nav-btn" title="Next Page" disabled={pageState.index >= totalPages - 1} onClick={() => {
                                    const idx = pageState.index + 1;
                                    pageDispatcher.updateIndex(idx);
                                    getSlideRecords(idx, pageState.number_of_items, pageDispatcher, '')
                                }}>
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                                </button>
                                {/* Last */}
                                <button className="nav-btn" title="Last Page" disabled={pageState.index >= totalPages - 1} onClick={() => {
                                    const idx = totalPages - 1;
                                    pageDispatcher.updateIndex(idx);
                                    getSlideRecords(idx, pageState.number_of_items, pageDispatcher, '')
                                }}>
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" /></svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    {pageState.modalVisible && <AddUploadSlide uploadShow={{ showUploadComponent, setShowUploadComponent }} selectedRowRecord={selectedRowRecord} />}

                    {/* AG-Grid Table */}
                    <div className="ag-theme-micalys">
                        <AgGridReact
                            colResizeDefault='shift'
                            domLayout="autoHeight"
                            rowHeight={120}
                            columnDefs={columnDefs}
                            rowData={pageState.slideList}
                            onGridReady={onGridReady}
                            onCellValueChanged={onCellValueChanged}
                            suppressNoRowsOverlay={true}
                        />
                    </div>
                    {pageState.slideList.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '40px 0', color: '#9CA3AF', fontSize: '14px' }}>
                            No slides to display
                        </div>
                    )}
                </>
            )}

            <SlideManageComponent stateVal={{ manageSlideState, setManageSlideState }} />

        </div>
    )
}

const TagsInput = (props) => {
    const { pageState, pageDispatcher } = useContext(PageContext);

    const initialState = {
        readOnly: true,
        inputbackgroundColor: '#cccccc',
        outline: 'none',
        tagArr: []
    }
    const [tagInputState, setTagInputState] = useState(initialState);
    useEffect(() => {
        if (props.taglistdata !== null) {
            setTagInputState({ ...tagInputState, tagArr: props.taglistdata })
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const deleteTag = (slide_id, idx) => {
        let arr = [...tagInputState.tagArr];
        const index = arr.indexOf(arr[idx]);
        if (index > -1) {
            arr.splice(index, 1);
        }
        let obj = {
            slide_id: slide_id,
            tags: JSON.stringify(arr)
        }
        save_updateTags(obj).then(async res => {
            if (res && res.data.message === 'success') {
                await getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '');
                await getSearchList(pageDispatcher);
            }
        })

    }

    return (
        <div
            style={{ overflowY: 'auto', width: 'auto', maxHeight: '130px', border: '1px solid gray' }}
        >
            <div className="input-tag">
                <ul className="input-tag__tags">
                    <li className="input-tag__tags__input">
                        <Form.Control size="sm" className="tag-input" type="text" style={{ position: 'sticky' }} placeholder="+ New Tag" onKeyDown={(event) => {
                            if (event.key === 'Enter' && event.target.value.trim().length !== 0) {

                                var data = pageState.slideList.filter(x => x.slide_id === props.slide_id);
                                let tagarr = [];

                                if (data && data[0].tagsarr !== null && data[0].tagsarr !== undefined) {
                                    tagarr = [...data[0].tagsarr]
                                    tagarr.unshift(event.target.value);
                                }
                                else {
                                    tagarr.push(event.target.value)
                                }
                                let obj = {
                                    slide_id: props.slide_id,
                                    tags: JSON.stringify(tagarr)
                                }
                                save_updateTags(obj).then(async res => {
                                    if (res && res.data.message === 'success') {
                                        await getSearchList(pageDispatcher)
                                        await getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '')
                                        setTagInputState({ ...tagInputState, readOnly: true, backgroundColor: '#cccccc', outline: 'none' });
                                    }
                                })
                            }
                        }
                        } />
                    </li>
                    <br />

                    {

                        tagInputState && tagInputState.tagArr && tagInputState.tagArr.map((tagitems, index) => {
                            return (

                                <li key={index}>
                                    {/* <span>{tagitems}</span> */}

                                    <input readOnly={tagInputState.readOnly} className="custometags" autoFocus
                                        type="text"
                                        value={tagitems}
                                        onDoubleClick={(event) => {
                                            event.stopPropagation();
                                            setTagInputState({ ...tagInputState, readOnly: false, backgroundColor: 'white', outline: '' })
                                            event.target.focus()
                                        }}
                                        onChange={(event) => {
                                            event.stopPropagation();
                                            let newArr = [...tagInputState.tagArr]

                                            var index = newArr.indexOf(tagitems);

                                            if (index !== -1) {
                                                newArr[index] = event.target.value;
                                            }
                                            setTagInputState({ ...tagInputState, tagArr: newArr })
                                        }}
                                        onKeyDown={(event) => {
                                            event.stopPropagation();
                                            if (event.key === 'Enter' && event.target.value.trim().length !== 0) {
                                                //update tag
                                                let arr = [...tagInputState.tagArr]
                                                let obj = {
                                                    slide_id: props.slide_id,
                                                    tags: JSON.stringify(arr)
                                                }
                                                save_updateTags(obj).then(async res => {
                                                    if (res && res.data.message === 'success') {
                                                        await getSearchList(pageDispatcher)
                                                        await getSlideRecords(pageState.index, pageState.number_of_items, pageDispatcher, '')
                                                        setTagInputState({ ...tagInputState, readOnly: true, backgroundColor: '#cccccc', outline: 'none' });

                                                    }
                                                })
                                            }
                                        }}
                                        style={{ outline: `${tagInputState.outline}`, backgroundColor: `${tagInputState.inputbackgroundColor}`, cursor: 'pointer' }}
                                    />
                                    <button type="button" onClick={() => deleteTag(props.slide_id, index)}>+</button>
                                </li>
                            )
                        })

                    }
                </ul>
            </div>
        </div >
    )
}


const SlideManageComponent = (props) => {
    const { pageState } = useContext(PageContext);
    const { manageSlideState, setManageSlideState } = props.stateVal
    // console.log("uid", pageState.userid)
    const handleClick = (groupid) => {
        let obj = {
            group_id: groupid,
            slide_id: manageSlideState.selectedSlideID
        }
        shareSlidetoGroup(obj).then(res => {
            if (res && res.data.Message) {
                NotificationManager.success(res.data.Message, '', 2000);
                setManageSlideState({ ...manageSlideState, modalVisible: false })
            }
            if (res && res.data.Msg) {
                NotificationManager.info(res.data.Msg, '', 2000);
            }
        })
    }
    return (
        <>
            <Modal backdrop="static" show={manageSlideState.modalVisible} onHide={() => setManageSlideState({ ...manageSlideState, modalVisible: false })} aria-labelledby="contained-modal-title-lg" size="md"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Group
                        {/* 
                        <Form className="d-flex">
                            <FormControl
                                type="search"
                                placeholder="Search"
                                className="me-2"
                                aria-label="Search"
                            />
                            <Button variant="outline-success"><i className="fa fa-search" aria-hidden="true"></i></Button>
                        </Form> */}

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        pageState && pageState.myJoinedGroups.length > 0 ? pageState.myJoinedGroups.map((item, key) => (
                            <ListGroup style={{ cursor: 'pointer' }} key={key}>
                                <ListGroup.Item disabled={pageState.userid !== item.group_admin_user ? true : false} onClick={() => handleClick(item.group_id)}>{item.group_name}

                                    {
                                        pageState.userid === item.group_admin_user &&
                                        <small style={{ color: 'green', float: 'right' }}><i className="fa fa-circle" aria-hidden="true"></i> Admin</small>
                                    }
                                </ListGroup.Item>
                            </ListGroup>
                        )) : <div>No Group Found.</div>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setManageSlideState({ ...manageSlideState, modalVisible: false })}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export const PageContext = createContext(null)

